// |-- Built-in Dependencies --|
import React from "react";
import { FormikProps } from "formik";

// |-- Internal Dependencies --|
import { FormInitialValues } from "../Add/AddDispositionLevelOneFormWrapper";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";

// |-- Types --|
type Props = {
  onClose: () => void;
  formikProps: FormikProps<FormInitialValues>;
  formType: "Add" | "Edit";
};

const DispositionLevelOneForm = ({ onClose, formikProps, formType }: Props) => {
  const { values, setFieldValue, handleBlur, isSubmitting, handleSubmit } =
    formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "Edit" ? "Update" : "Add"} disposition first
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <div>
            <ATMTextField
              name="dispositionFirstName"
              value={values.dispositionFirstName}
              placeholder="Enter disposition first name"
              label="Disposition First Name"
              onBlur={handleBlur}
              onChange={(e) =>
                setFieldValue("dispositionFirstName", e.target.value)
              }
            />
          </div>
        </div>
      </div>
      <div>
        <ATMLoadingButton
          isLoading={isSubmitting}
          type="submit"
          onClick={() => handleSubmit()}
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default DispositionLevelOneForm;
